/* Slick & Pop Duo landing page — Watch & Sea
   AJAX add-to-cart, reveal-on-scroll, sticky buy bar.
   Idempotent: safe to re-run on shopify:section:load. */
(function () {
  'use strict';

  var DRAWER_SELECTORS = [
    '[id*="upcart" i]',
    '[class*="upcart" i]',
    '[data-section-type="quick-cart"]',
    '[class*="quick-cart" i]',
    '[class*="cart-drawer" i]'
  ].join(',');

  // A drawer counts as "open" only if it is actually on screen: closed
  // off-canvas drawers keep their layout size, so offsetWidth alone lies.
  function isOnScreen(el) {
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    return rect.left < window.innerWidth && rect.right > 0 &&
           rect.top < window.innerHeight && rect.bottom > 0;
  }

  function hasOpenMarker(el) {
    if (el.getAttribute('aria-hidden') === 'false') return true;
    return /(^|[\s_-])(open|opened|active|visible|show|shown)([\s_-]|$)/i.test(el.className);
  }

  function visibleDrawers() {
    var out = [];
    document.querySelectorAll(DRAWER_SELECTORS).forEach(function (el) {
      if (isOnScreen(el)) out.push(el);
    });
    return out;
  }

  // Open = a drawer element is on screen now that was not before the add,
  // or an existing one flipped to an explicit open state.
  function drawerNewlyOpened(before) {
    var after = visibleDrawers();
    for (var i = 0; i < after.length; i++) {
      if (before.indexOf(after[i]) === -1) return true;
      if (hasOpenMarker(after[i]) && !after[i].dataset.gjdWasOpen) return true;
    }
    return false;
  }

  function markOpenState(drawers) {
    drawers.forEach(function (el) {
      if (hasOpenMarker(el)) el.dataset.gjdWasOpen = '1';
      else delete el.dataset.gjdWasOpen;
    });
  }

  function updateCartCounts(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    var els = document.querySelectorAll('[data-cart-count], [data-js-cart-count], .cart-count');
    els.forEach(function (el) { el.textContent = cart.item_count; });
  }

  function bindForm(form) {
    if (form.dataset.gjdBound) return;
    form.dataset.gjdBound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var label = form.querySelector('[data-gjd-atc-text]');
      if (!button || button.disabled || button.classList.contains('is-busy')) return;

      var originalHTML = label ? label.innerHTML : '';
      button.classList.add('is-busy');
      if (label) label.textContent = 'Adding…';

      var drawersBefore = visibleDrawers();
      markOpenState(drawersBefore);

      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var payload = {
        items: [{
          id: parseInt(idField && idField.value, 10),
          quantity: parseInt((qtyField && qtyField.value) || '1', 10)
        }]
      };

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          button.classList.remove('is-busy');
          button.classList.add('is-added');
          if (label) label.textContent = 'Added ✓';

          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(updateCartCounts)
            .catch(function () {});

          var restore = function () {
            button.classList.remove('is-added');
            if (label) label.innerHTML = originalHTML;
          };

          // Open the site's side cart (UpCart) via its API.
          if (typeof window.upcartRefreshCart === 'function' &&
              typeof window.upcartOpenCart === 'function') {
            try {
              window.upcartRefreshCart();
              window.upcartOpenCart();
            } catch (apiErr) {}
            window.setTimeout(restore, 2200);
            return;
          }

          // No UpCart: if some other drawer opened on its own, stay put.
          // Otherwise take the shopper to the cart so the add is never silent.
          window.setTimeout(function () {
            if (!drawerNewlyOpened(drawersBefore)) {
              window.location.href = '/cart';
              return;
            }
            window.setTimeout(restore, 2200);
          }, 900);
        })
        .catch(function (err) {
          button.classList.remove('is-busy');
          if (label) label.textContent = (err && err.description) ? err.description : 'Try again';
          window.setTimeout(function () {
            if (label) label.innerHTML = originalHTML;
          }, 2600);
        });
    });
  }

  function initReveals(root) {
    var items = root.querySelectorAll('[data-gjd-reveal]:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    root.classList.add('gjd--js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-gjd-sticky]');
    var hero = root.querySelector('.gjd-hero');
    if (!bar || !hero) return;
    if (bar.dataset.gjdBound) return;
    bar.dataset.gjdBound = '1';

    if (window.sessionStorage && sessionStorage.getItem('gjd-sticky-dismissed')) return;

    var closeBtn = bar.querySelector('[data-gjd-sticky-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        try { sessionStorage.setItem('gjd-sticky-dismissed', '1'); } catch (e) {}
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var heroVisible = entries[entries.length - 1].isIntersecting;
      var show = !heroVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(hero);
  }

  function init() {
    var root = document.querySelector('.gjd');
    if (!root) return;
    root.querySelectorAll('[data-gjd-atc-form]').forEach(bindForm);
    initReveals(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
